import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ClienteFormInputDisabledComponent } from './cliente-form-input-disabled.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteFormInputDisabledComponent
    ],
    exports: [
        ClienteFormInputDisabledComponent
    ]
})
export class ClienteFormInputDisabledModule { }
